<template>
  <div class="organizationHeader" :style="headerStyle">
    <div class="container pb-1 h-100 d-flex flex-column">
      <div class="flex-fill">
        <div class="row">
          <div class="col-md-12 mt-1">
            <h1 v-if="isLoading" class="organizationName p-3 mb-3 mt-0">
              Loading Hub...
            </h1>
            <i class="fa fa-3x fa-spin fa-spinner ml-4" v-if="isLoading"></i>
            <h1 v-else class="text-left p-3 mb-0 mt-2 w-100">
                    <span class="d-none d-lg-inline mb-1 align-text-bottom float-right pt-1"
                          v-if="!isLoading">
                      <img class='organizationPicture rounded-circle' :src="logo" alt="Hub Logo"/>
                    </span>
              <span class="col col-md-10 mx-auto float-left"><span class="organizationName">{{ organization.name }} Hub</span></span>
            </h1>
          </div>
        </div>
      </div>
      <div class="flex-none mt-2">
        <div class="row h-100 align-items-end">
          <div class="col-lg-2"></div>
          <div class="col-lg-8 order-3 order-lg-2 mb-2">
            <organizationStats v-if="!isLoading"></organizationStats>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import organizationStats from "./organizationStats";

export default {
  components: {
    organizationStats
  },
  computed: {
    ...mapGetters({
      organization: "organization/get/organization",
      isLoading: "organization/get/isLoading"
    }),
    headerStyle() {
      return {
        backgroundImage: `url(${
          this.organization && this.organization.banner
            ? this.organization.banner.path
            : "/assets/images/header/default-project-header-banner.png"
        })`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
      };
    },
    logo() {
      return this.organization && this.organization.logo
        ? this.organization.logo.path
        : '/assets/images/logo.png';
    },
  }
};
</script>

<style lang="scss" scoped>
.organizationHeader {
  min-height: 280px;
  background-color: #333;

  // Responsive heights based on viewport width
  @media (min-width: 576px) {
    min-height: 300px;
  }

  @media (min-width: 768px) {
    min-height: 320px;
  }

  @media (min-width: 992px) {
    min-height: 340px;
  }

  // On large screens, use aspect ratio for consistent proportions
  @media (min-width: 1200px) {
    aspect-ratio: 5 / 1;
    min-height: 280px;
  }
}

.organizationName {
  color: white;
  background: rgba(0, 0, 0, 0.5);
  display: inline;
  float: left;
  font-size: 3.5rem !important;
  padding-top: 12px;
  padding-left: 6px;
  padding-right: 6px;
}

.organizationPicture {
  width: 160px;
  height: 160px;
  max-height: 160px;
  max-width: 160px;
  border: solid 1px white;
}
</style>
